import { useMediaQuery, Box, Skeleton, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useSettings, ApiQueries, StudentItem } from "daymap-react";
import { useState, useEffect } from "react";

type AbsentInboundFormProps = {
    date?:Date,
    students?:number[],
    reason: string,
    onChange: (args: AbsentInboudFormChangedArgs) => void
}

export type AbsentInboudFormChangedArgs = {
    date?: Date;
    reason: string;
    studentIds: number[]
}

export const AbsentInboundForm: React.FC<AbsentInboundFormProps> = ({date, reason, students, onChange}) => {
    const { settings, isPending } = useSettings();
    const [selectedStudentIds, setSelectedStudentIds] = useState<number[]>(students ?? []);
    const { data: absentReasons, isPending: reasonsPending } = new ApiQueries.attendance.absentReasons({}).ToQuery();
    const md = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    
    const HandleChange = (args:AbsentInboudFormChangedArgs) => {
        onChange(args);
    }

    useEffect(() => {
        setSelectedStudentIds(students ? students : []);
    }, [students]);

    if (isPending || reasonsPending)
        return <Box display="flex" flexDirection="column" gap={1}>
            <Skeleton variant="rectangular"></Skeleton>
            <Skeleton variant="rectangular"></Skeleton>
        </Box>

    return <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" flexDirection={md ? "column" : "row"} gap={2}>
            <FormControl>
                <DatePicker label="Date of absence" value={date ? dayjs(date) : dayjs()} onChange={d => d?.isValid() && HandleChange({date:d!.toDate(),reason,studentIds:selectedStudentIds })} />
            </FormControl>
            {settings?.Messaging.ParentsSelectAbsenceReason && absentReasons!.length > 0 && <>
                <FormControl sx={{ flexGrow: 1}}>
                    <InputLabel id="reason-label">Absent Reason</InputLabel>
                    <Select labelId="reason-label" label="Absent Reason" value={reason} onChange={e => HandleChange({date,reason:e.target.value,studentIds:selectedStudentIds })}>
                        {absentReasons!.map(r => <MenuItem key={r.Code} value={r.Code}>{r.Description}</MenuItem>)}
                    </Select>
                </FormControl>
            </>}
        </Box>
        <Box>
            <InputLabel>Absent Students (tap to select)</InputLabel>
            <StudentPicker selectedIds={selectedStudentIds} onChange={(ids) => HandleChange({date,reason,studentIds:ids })} />
        </Box>
    </Box>
}

export const StudentPicker: React.FC<{selectedIds: number[], onChange: (selectedIds:number[]) => void}> = ({onChange, selectedIds}) => {
    const { isPending, data } = new ApiQueries.contact.studentsForContact().ToQuery();
    const md = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const studentClicked = (studentId: number) => {
        console.log(studentId, selectedIds);
        if (selectedIds.indexOf(studentId) > -1) {
            onChange(selectedIds.filter(id => id !== studentId));
            console.log('removed')
        } else { 
            console.log('added')
            onChange([...selectedIds, studentId]);
        }
    }

    if (isPending)
        return <Box display="flex" flexDirection={md ? "column" : "row"} gap={1}>
            <Skeleton variant="rectangular" height={50} />
            <Skeleton variant="rectangular" height={50} />
        </Box>

    return <Box display="flex" flexDirection={md ? "column" : "row"} gap={1}>
        {data!.map(s => <StudentItem key={s.ContactID}
            displayName={s.DisplaynameSurname} 
            contactId={s.ContactID} 
            onClick={() => studentClicked(s.ID)} 
            selected={selectedIds.indexOf(s.ID) > -1} />)}
    </Box>
}